/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkFlowEventHistory {
    getFixupPrototypeFunction() { return WorkFlowEventHistory.fixupPrototype; }

    static newInstance(model: Partial<WorkFlowEventHistory>): WorkFlowEventHistory {
        let obj = Object.assign(new WorkFlowEventHistory(), model);
        WorkFlowEventHistory.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkFlowEventHistory>): WorkFlowEventHistory {
        if (!model) return null;
        return WorkFlowEventHistory.newInstance(<WorkFlowEventHistory> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkFlowEventHistory) {
        if (!obj) return;

        models.WorkFlowEventHistory.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkFlowEventHistory): boolean {
        Object.setPrototypeOf(obj, WorkFlowEventHistory.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.performed_at === "string") {
            this.performed_at = new Date(<string><any>this.performed_at);
        }
    }

    /**
     * Step wise status of the workflow.
     */
    event_name: models.WorkFlowLifeCycleStatus;

    /**
     * The time at which the event has occur
     */
    performed_at: Date;

    /**
     * The status of the event which has been performed while doing automation workflow.
     */
    event_status: string;

    /**
     * Failure Reason if any available for the step.
     */
    failure_reason: string;

}
